import { useQuery } from "@tanstack/react-query";

import { ListPromocodesQueryFilters, UseListPromocodesQueryOptions } from "./types";
import { getPromocodesService } from "./service";

export const listPromocodesQueryKey = ["promocode_admin"];

export function useListPromocodesQuery(
  filters?: ListPromocodesQueryFilters,
  options?: UseListPromocodesQueryOptions
) {
  const queryKey = listPromocodesQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getPromocodesService(filters),
    ...options,
  });
}
